import {FC, HTMLAttributes} from 'react'

export const ChevronIcon: FC<{size?: number} & HTMLAttributes<SVGSVGElement>> = ({size = 16, ...rest}) => (
    <svg width={size} height={size} viewBox="0 0 16 16" fill="none" {...rest}>
        <path d="M10 12L6 8L10 4" stroke="#7E868C" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
)
